// extracted by mini-css-extract-plugin
export default {"modal_content_wrapper":"styles_modal_content_wrapper__HgFA+","modal_header":"styles_modal_header__+-ZOk"};